import Divider from 'antd/lib/divider';
import Layout from 'antd/lib/layout';
import * as React from 'react';

export interface ChildrenFunctionParams {
    contentHeight: number;
}

interface SetupStepsContainerProps {
    navigationBar?: React.ReactNode;
    sideBar?: React.ReactNode;
    footer?: React.ReactNode;
    banner?: React.ReactNode | ((params: ChildrenFunctionParams) => React.ReactNode);
    children?: React.ReactNode | ((params: ChildrenFunctionParams) => React.ReactNode);
}

export const CommonSetupFlowLayout: React.FC<SetupStepsContainerProps> = ({
    navigationBar,
    sideBar,
    banner,
    footer,
    children,
}) => {
    const [stepContainerHeight, setStepContainerHeight] = React.useState(0);
    const stepContainerRef = React.useRef(null);

    React.useEffect(() => {
        setStepContainerHeight(stepContainerRef.current.scrollHeight);
    }, []);

    const processedChildren =
        typeof children === 'function' ? children({ contentHeight: stepContainerHeight }) : children;

    const processedBanner = typeof banner === 'function' ? banner({ contentHeight: stepContainerHeight }) : banner;

    return (
        <Layout>
            {navigationBar}
            <div
                ref={stepContainerRef}
                style={{
                    flex: 1,
                    overflowY: 'auto',
                }}
            >
                {processedBanner}
                <div style={{ display: 'flex', flex: 1, zIndex: 0 }}>
                    <div style={{ flex: 1, padding: 36 }}>
                        <div
                            style={{
                                position: 'relative',
                                overflowY: 'scroll',
                                height: '100%',
                                width: '100%',
                            }}
                        >
                            {processedChildren}
                        </div>
                    </div>
                    <Divider type="vertical" style={{ height: 'auto' }} />
                    <div style={{ maxWidth: 480, flex: 1, padding: 36 }}>{sideBar}</div>
                </div>
            </div>
            {footer}
        </Layout>
    );
};
